/**
 * Holds the undoredo state when performing a rotation, translation or scaling. The adorner is optional.
 *
 * @type {*}
 */
class TransformUnit {
    constructor(shapes, undoStates, adorner) {
        this.shapes = shapes;
        this.undoStates = undoStates;
        this.title = 'Transformation';
        this.redoStates = [];
        this.adorner = adorner;
        for (let i = 0; i < this.shapes.length; i++) {
            const shape = this.shapes[i];
            this.redoStates.push(shape.bounds());
        }
    }
    undo() {
        for (let i = 0; i < this.shapes.length; i++) {
            const shape = this.shapes[i];
            shape.bounds(this.undoStates[i]);
            if ('layout' in shape) {
                shape.layout(shape, this.redoStates[i], this.undoStates[i]);
            }
            shape.updateModel();
        }
        if (this.adorner) {
            this.adorner.refreshBounds();
            this.adorner.refresh();
        }
    }
    redo() {
        for (let i = 0; i < this.shapes.length; i++) {
            const shape = this.shapes[i];
            shape.bounds(this.redoStates[i]);
            // the 'layout' property, if implemented, lets the shape itself work out what to do with the new bounds
            if ('layout' in shape) {
                shape.layout(shape, this.undoStates[i], this.redoStates[i]);
            }
            shape.updateModel();
        }
        if (this.adorner) {
            this.adorner.refreshBounds();
            this.adorner.refresh();
        }
    }
}

export { TransformUnit };
